import type { RoomSnapshot } from '../../lib/api/rooms'
import { useT } from '../../i18n'

interface Props {
  snapshot: RoomSnapshot
  myId: string | null
}

/**
 * Phone-side results screen. The TV owns the leaderboard theatre — the
 * phone just confirms their personal score and nudges them to look up.
 */
export function JoinResultsPhase({ snapshot, myId }: Props) {
  const t = useT()
  const { players, submissions, courseVotes } = snapshot
  const me = players.find(p => p.profile_id === myId) ?? null
  const mySub = me ? submissions.find(s => s.player_id === me.id) ?? null : null

  const myVotes = mySub
    ? courseVotes.filter(cv => cv.submission_id === mySub.id)
    : []
  const yes = myVotes.filter(v => v.would_eat).length
  const no  = myVotes.filter(v => !v.would_eat).length

  return (
    <div className="flex-1 flex flex-col items-center justify-center px-6 py-10 text-center">
      <p className="text-5xl mb-4">🏁</p>
      <p className="text-xs font-semibold uppercase tracking-widest text-brand-muted mb-1">{t("That's a wrap")}</p>
      <h1 className="font-display text-3xl font-bold text-brand-text mb-1">{t('Thanks for playing')}</h1>
      <p className="text-brand-muted mb-8">{t("Leaderboard's on the TV.")}</p>

      {me && (
        <div className="card-lg p-6 w-full max-w-sm mb-8">
          <p className="text-xs font-semibold uppercase tracking-widest text-brand-muted mb-2">{t('Your meal scored')}</p>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="font-display text-4xl font-bold text-iet-green">{yes}</p>
              <p className="text-xs text-brand-muted uppercase tracking-wide">{t("I'd eat that")}</p>
            </div>
            <div>
              <p className="font-display text-4xl font-bold text-brand-danger">{no}</p>
              <p className="text-xs text-brand-muted uppercase tracking-wide">{t('Hard pass')}</p>
            </div>
          </div>
        </div>
      )}

      <p className="text-sm text-brand-muted">{t("Hit Leave above when you're ready for another round.")}</p>
    </div>
  )
}
